/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SearchLocationsByStringQueryVariables = Types.Exact<{
  searchString: Types.Scalars['String'];
  showHidden?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;

export type SearchLocationsByStringQuery = {
  readonly __typename?: 'Query';
  readonly searchLocationsByString: ReadonlyArray<{
    readonly __typename?: 'LocationSearchResult';
    readonly score: number;
    readonly location: {
      readonly __typename?: 'StoreLocation';
      readonly id: string;
      readonly name: string;
      readonly address: string;
      readonly city: string;
      readonly state: string;
      readonly zipCode: string;
      readonly isOutpost: boolean | null;
      readonly phone: string | null;
      readonly storeHours: string | null;
      readonly flexMessage: string | null;
      readonly enabled: boolean;
      readonly acceptingOrders: boolean;
      readonly notAcceptingOrdersReason: string | null;
      readonly imageUrl: string;
      readonly hidden: boolean;
      readonly showWarningDialog: boolean;
      readonly warningDialogDescription: string | null;
      readonly warningDialogTimeout: number | null;
      readonly warningDialogTitle: string | null;
      readonly lat: number;
      readonly lng: number;
      readonly restaurantSlug: string;
    };
  } | null> | null;
};

export const searchLocationsByStringQueryMock: ExecutionResult<SearchLocationsByStringQuery> =
  {
    data: {
      searchLocationsByString: [
        {
          score: -27.84,
          location: {
            id: '09e6ea9f-ee42-4a99-a258-7ce71904308d',
            name: 'Hello World',
            lat: 37.39,
            lng: -10.27,
            restaurantSlug: 'Hello World',
            address: 'Hello World',
            city: 'Hello World',
            state: 'Hello World',
            zipCode: 'Hello World',
            isOutpost: true,
            phone: 'Hello World',
            storeHours: 'Hello World',
            flexMessage: 'Hello World',
            enabled: false,
            acceptingOrders: false,
            notAcceptingOrdersReason: 'Hello World',
            imageUrl: 'Hello World',
            hidden: false,
            showWarningDialog: false,
            warningDialogDescription: 'Hello World',
            warningDialogTimeout: 43.11,
            warningDialogTitle: 'Hello World',
          },
        },
        {
          score: 35.25,
          location: {
            id: '7eda96e8-a185-4e3d-a00a-9a47534319d0',
            name: 'Hello World',
            lat: 1.48,
            lng: -90.37,
            restaurantSlug: 'Hello World',
            address: 'Hello World',
            city: 'Hello World',
            state: 'Hello World',
            zipCode: 'Hello World',
            isOutpost: false,
            phone: 'Hello World',
            storeHours: 'Hello World',
            flexMessage: 'Hello World',
            enabled: false,
            acceptingOrders: true,
            notAcceptingOrdersReason: 'Hello World',
            imageUrl: 'Hello World',
            hidden: false,
            showWarningDialog: true,
            warningDialogDescription: 'Hello World',
            warningDialogTimeout: 27.61,
            warningDialogTitle: 'Hello World',
          },
        },
        {
          score: 34.64,
          location: {
            id: '250f9c40-16b1-4bd6-b4cb-273b7f9f18d0',
            name: 'Hello World',
            lat: -62.03,
            lng: -99.05,
            restaurantSlug: 'Hello World',
            address: 'Hello World',
            city: 'Hello World',
            state: 'Hello World',
            zipCode: 'Hello World',
            isOutpost: true,
            phone: 'Hello World',
            storeHours: 'Hello World',
            flexMessage: 'Hello World',
            enabled: false,
            acceptingOrders: true,
            notAcceptingOrdersReason: 'Hello World',
            imageUrl: 'Hello World',
            hidden: false,
            showWarningDialog: true,
            warningDialogDescription: 'Hello World',
            warningDialogTimeout: -65.63,
            warningDialogTitle: 'Hello World',
          },
        },
      ],
    },
  };

export const SearchLocationsByStringDocument = gql`
  query SearchLocationsByString($searchString: String!, $showHidden: Boolean) {
    searchLocationsByString(
      searchString: $searchString
      showHidden: $showHidden
    ) {
      score
      location {
        id
        name
        lat: latitude
        lng: longitude
        restaurantSlug: slug
        address
        city
        state
        zipCode
        isOutpost
        phone
        storeHours
        flexMessage
        enabled
        acceptingOrders
        notAcceptingOrdersReason
        imageUrl
        hidden
        showWarningDialog
        warningDialogDescription
        warningDialogTimeout
        warningDialogTitle
      }
    }
  }
`;

export function useSearchLocationsByStringQuery(
  options: Omit<
    Urql.UseQueryArgs<SearchLocationsByStringQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    SearchLocationsByStringQuery,
    SearchLocationsByStringQueryVariables
  >({ query: SearchLocationsByStringDocument, ...options });
}
